import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
//import Stack from '@mui/material/Stack';

export default function Circular() {
  return (
    <Box sx={{
        display: 'flex',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
    }}>
      <CircularProgress />
    </Box>
  );
}
